import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const DEFAULT_COLORS = ['#6f020d', '#e07b7b', '#7c3aed', '#16a34a', '#f59e0b', '#0ea5e9'];

/**
 * Donut breakdown chart — Production Incident "by Identified By", Service Disruption
 * "Identified By" / "Rootcause".
 */
function DonutBreakdown({ data, dimensionKey = 'bucket', valueKey = 'count', colors = DEFAULT_COLORS, height = 220 }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          dataKey={valueKey}
          nameKey={dimensionKey}
          innerRadius="45%"
          outerRadius="75%"
          paddingAngle={1}
        >
          {data.map((_, i) => <Cell key={i} fill={colors[i % colors.length]} />)}
        </Pie>
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 11 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default DonutBreakdown;
